/* istanbul ignore file */
import React from 'react';
import { CREATE_JOURNAL_ENTRY } from 'domain/finance/journalEntry/useJournalEntryService';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import { useAuthorization } from 'framework/authorization';
import { LinkButton } from 'framework/ui/ui-builder';

const ReverseJournalEntryButton = () => {
  const { getReverseEntityUrl } = useJournalEntryUrl();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_JOURNAL_ENTRY) ? (
    <LinkButton variant="outlined" url={getReverseEntityUrl()}>
      Storno
    </LinkButton>
  ) : null;
};

export default ReverseJournalEntryButton;
